import lang from "translations";

export const preAuthTransactionColumns = [
  {
    key: "id",
    text: lang.id,
    maxWidth: "max-content",
    custom: true
  },
  {
    key: "user",
    text: lang.guest,
    maxWidth: "max-content",
    custom: true
  },
  {
    key: "amount",
    text: lang.amount,
    maxWidth: "max-content",
    custom: true
  },
  {
    key: "paidAmount",
    text: "Paid Amount",
    maxWidth: "max-content",
    custom: true
  },  
  {
    key: "transactionStatus",
    text: lang.status,
    maxWidth: "max-content",
    custom: true,
  }  
];

